import { z } from 'zod';

/**
 * POST /api/chat/report-user - Report a user
 */
export const ReportUserRequestSchema = z.object({
  /** The ID of the user to report */
  userId: z.number(),
  /** Description of the issue */
  details: z.string().min(1, 'Please describe the issue'),
  /** Optional chat ID for context */
  chatId: z.number().optional(),
});

/**
 * Success response for report operation
 */
export const ReportUserSuccessResponseSchema = z.object({
  success: z.literal(true),
  message: z.string().optional(),
});

/**
 * Error response for report operation
 */
export const ReportUserErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
});

/**
 * Combined response schema for report operation
 */
export const ReportUserResponseSchema = z.discriminatedUnion('success', [
  ReportUserSuccessResponseSchema,
  ReportUserErrorResponseSchema,
]);

export type ReportUserRequest = z.infer<typeof ReportUserRequestSchema>;
export type ReportUserSuccessResponse = z.infer<typeof ReportUserSuccessResponseSchema>;
export type ReportUserErrorResponse = z.infer<typeof ReportUserErrorResponseSchema>;
export type ReportUserResponse = z.infer<typeof ReportUserResponseSchema>;
